import { Component, Input, OnInit, ChangeDetectionStrategy, inject } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatCheckboxChange, MatCheckbox } from "@angular/material/checkbox";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { firstValueFrom } from "rxjs";
import { MatError } from "@angular/material/form-field";

export interface TimeSlotDaily {
  dayIndex: number; // 0 = monday
  timeIndex: number; // 0 = morning, 1 = afternoon
}

@Component({
  selector: "app-time-slots-daily",
  templateUrl: "./time-slots-daily.component.html",
  styleUrls: ["./time-slots-daily.component.less"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatError, MatCheckbox, TranslatePipe],
})
export class TimeSlotsDailyComponent implements OnInit {
  private readonly translateService = inject(TranslateService);

  @Input()
  public formgroup!: FormGroup;

  public dates: Date[];
  public days: string[];
  public selectedSlots: TimeSlotDaily[];

  public constructor() {
    this.dates = [];
    this.days = [];
    this.selectedSlots = [];
  }

  public async ngOnInit(): Promise<void> {
    this.dates = this.getWeekDates();
    this.days = await firstValueFrom(this.translateService.get("COMPONENTS.TIME_SLOTS_DAILY.DAYS"));
    this.formgroup.addControl("timeSlotsDaily", new FormControl<string[]>(["0", "0", "0", "0", "0", "0"]));
    this.formgroup.get("timeSlotsDaily")?.setErrors({ minLength: 1 });
  }

  public onCheckboxChange(event: MatCheckboxChange, checkbox: { day: number; value: number }): void {
    const control = this.formgroup.get("timeSlotsDaily") as FormControl<string[]>;

    control.setValue(
      control.value.map((current, index) => {
        if (index === checkbox.day) {
          if (event.checked) {
            return (parseInt(current) + checkbox.value).toString();
          } else {
            return (parseInt(current) - checkbox.value).toString();
          }
        } else {
          return current;
        }
      }),
    );
    console.log(control.value);

    control.setErrors(control.value.some((x) => parseInt(x) > 0) ? null : { minLength: 1 });
    control.markAsTouched();
    control.markAsDirty();
  }

  private getWeekDates(): Date[] {
    const today = new Date();
    const day = today.getDay();
    const monday = new Date(today);
    const diffToMonday = day === 0 ? -6 : 1 - day;

    monday.setDate(today.getDate() + diffToMonday);
    const weekDates: Date[] = [];
    for (let i = 0; i < 6; i++) {
      const date = new Date(monday);
      date.setDate(monday.getDate() + i);
      weekDates.push(date);
    }

    return weekDates;
  }
}
